import { useEffect, useRef } from 'react';
import { getAdSenseClientId, getAdSenseSlotId } from '@/lib/adsense-config';

interface AdSenseAdProps {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal';
  responsive?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export function AdSenseAd({
  slot,
  format = 'auto',
  responsive = true,
  style,
  className = '',
}: AdSenseAdProps) {
  const publisherId = getAdSenseClientId();
  const resolvedSlot = getAdSenseSlotId(slot);
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    if (!publisherId || !resolvedSlot) return;

    try {
      if (window.adsbygoogle && adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error('AdSense ad load error:', e);
    }
  }, [publisherId, resolvedSlot]);

  if (!publisherId || !resolvedSlot) {
    return null;
  }

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle ${className}`}
      style={{ display: 'block', ...style }}
      data-ad-client={publisherId}
      data-ad-slot={resolvedSlot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
    />
  );
}
